import type { FunnelPageType } from '@template-project/funnels-contract';
import type { StepExperience } from './types';

const STEP_TYPE_PAGE: Readonly<Record<string, FunnelPageType>> = {
  product_page: 'product_page',
  collection: 'collection',
  homepage: 'homepage',
  landing_page: 'landing_page',
  offer_page: 'landing_page',
  cart: 'cart',
  checkout: 'checkout',
  thank_you: 'thank_you',
  upsell: 'post_purchase',
  downsell: 'post_purchase',
};

/**
 * Whether a server-returned next step belongs on the page that initiated the
 * transition. Cross-page transitions are persisted but must wait for the
 * destination page to evaluate them.
 */
export function isStepCompatibleWithPage(
  step: StepExperience,
  pageType: FunnelPageType,
): boolean {
  const placement = step.placement?.trim().toLowerCase();
  if (placement) {
    return placement === pageType ||
      (placement === 'offer_page' && pageType === 'landing_page');
  }

  const stepType = step.stepType?.trim().toLowerCase();
  return stepType ? STEP_TYPE_PAGE[stepType] === pageType : false;
}
